import styled from 'styled-components';

import { Typography } from 'components';

export const TicketETA = styled(Typography)`
  color: ${props => props.theme.custom.palette.success600};
  font-weight: 700;
  font-size: 1.4rem;
`;
